/* eslint-disable react/prop-types */
import { useState } from 'react';
import styles from './styles.module.css';
import { useNavigate } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import { Cross } from '../../assets/svgs/icons';
import Loading from '../Loading';
const ModalValidParameter = ({
  onClose,
  handleCloseModal,
  isOpen,
  campaignItemRef,
  wantToKeepParameters,
}) => {
  if (!isOpen) return null;

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleParametrization = async () => {
    await wantToKeepParameters(true);

    navigate('/ChatSocket', {
      state: {
        uncompletedCampaign: true,
        campaignItemRef: campaignItemRef.current,
      },
    });

    handleCloseModal(false);
  };

  return (
    <div className={styles.modal_overlay}>
      <div className={styles.modal}>
        <Loading enable={loading} />

        <div className={styles.header_close}>
          <div className={styles.close_modal} onClick={onClose}>
            <Cross width={'20px'} height={'20px'} />
          </div>
        </div>

        <div className={styles.modal_title}>
          <h2> {t('modal_campaign_parameters.title')}</h2>
        </div>

        <div className={styles.modal_sub_title}>
          <p className={styles.modal_sub_title_text}>
            {t('modal_campaign_parameters.description')}
          </p>

          <p className={styles.modal_sub_title_text}>
            {t('modal_campaign_parameters.footer')}
          </p>
        </div>

        <div className={styles.modal_container_drag}>
          <button className={styles.button_back} onClick={onClose}>
            {t('modal_campaign_parameters.back')}
          </button>

          <button
            className={styles.button_send}
            onClick={() => {
              setLoading(true);
              handleParametrization();
            }}
          >
            {t('modal_campaign_parameters.continue')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalValidParameter;
